module.exports = __webpack_public_path__ + "static/img/notify-1.9c6db35c.png";